import { render, staticRenderFns } from "./defaultRestorePass.vue?vue&type=template&id=01c3b512"
import script from "./defaultRestorePass.vue?vue&type=script&lang=js"
export * from "./defaultRestorePass.vue?vue&type=script&lang=js"
import style0 from "./defaultRestorePass.vue?vue&type=style&index=0&id=01c3b512&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports